<template>
   <div class="main-banner rounded-2xl w-[95%] md:w-[80%] m-auto p-3 md:p-6" id="about">
      <h1 class="text-white text-center font-bold text-3xl mt-5 mb-3 mb:mb-6">What can you do with Exhnge?</h1>
      <div class="flex flex-col md:flex-row ">
         <div class="p-4 border-b-2  border-[#580355] md:border-b-0  md:border-r-2 md:border-[#580355]">
            <img  class="m-auto p-4 bg-[#580355]  text-black w-[90px] rounded-full" src="@/assets/Images/Vector-arrow.svg" onerror="this.style.display='none'">               
            <h2 class="text-center text-white font-semibold text-3xl mt-2 mb-2">Exchange</h2>
            <p class="text-[#eee] font-light">
            If you want to buy or sell cryptocurrencies, opening an account with a crypto-currency exchange is a great way to start. Crypto exchan-ges function similarly to online brokerage platforms, providing you with the tools you need to buy and sell digital currencies and tokens like Bitcoin, Ethereum, and Dogecoin. 
            It’s important to look at factors such as supported as-sets, fees, payment methods, and security.
            </p>
         </div>
         <div class="p-4 border-b-2 border-[#580355] md:border-b-0 md:border-r-2 md:border-[#580355]">
            <img  class="m-auto p-4 bg-[#580355]  text-black w-[90px] rounded-full" src="@/assets/Images/circular.svg" onerror="this.style.display='none'">
            <h2 class="text-center text-white font-semibold text-3xl mt-2 mb-2">Track Changes</h2>
            <p class="text-[#eee] font-light">
              It’s smart to use a crypto portfolio tracker and bring all your investments under one hood. Let’s find the best ones to make crypto investments easy and efficient.
              The best crypto portfolio tracker is Exhnge. Most intermediate and advanced crypto traders store funds across multiple blockchains and use different wallets for different purposes. This can make tracking your crypto net worth a major pain in the neck.
            </p>
         </div>
         <div class="p-4">
            <div class="rounded-full m-auto p-4 bg-[#580355]  text-black w-[90px]">
               <img class="w-[120px]" src="@/assets/Images/fast.svg" onerror="this.style.display='none'">
            </div>
            <h2  class="text-center text-white font-semibold text-3xl mt-2 mb-2">Smart Transaction</h2>
            <p class="text-[#eee] font-light">
               Anyone can perform a smart Transaction and use it on the network. This is very useful for avoiding single points of failure for contracts holding substantial amounts of ether or other tokens. Multisigs also divide responsibility for contract execution
               and key management between multi-ple parties and prevent the loss of a single private key leading to irreversible loss of funds.
            </p>
         </div>
      </div>
   </div>
</template>
<style scoped>
   .enter {
      display: none;
   }
</style>